import { FormatterEx } from 'slickgrid';

export interface CheckboxFormatterOptions {}

export function checkbox<T>(opts: CheckboxFormatterOptions): FormatterEx<T> {
  const readonly = 'onclick="return false;"';

  const checkboxFormatter: FormatterEx<T> = (
    row,
    cell,
    value,
    columnDef,
    data,
  ) => {
    if (data) {
      return value
        ? `<input type="checkbox" checked="checked" ${readonly}/>`
        : `<input type="checkbox" ${readonly}/>`;
    }

    return '';
  };

  checkboxFormatter.exportRawData = true;

  return checkboxFormatter;
}
